import React, { useState } from 'react';
import { BarChart3, Gauge, Map as MapIcon, Mountain, Sprout } from 'lucide-react';

// Sección Mapa de la landing: capturas reales del mapa de la app (recortes de las
// mismas tomas de la tablet del hero, cuenta de prueba local, sept 2026) con una
// lista a la izquierda para pasar de una vista a otra.

const VISTAS = [
  { src: '/landing/mapa/satelite.webp', title: 'Potreros y aguadas', desc: 'Dibujados sobre la foto satelital.', alt: 'Cuadros, aguadas y alambrados dibujados sobre la foto satelital del campo', Icon: MapIcon },
  { src: '/landing/mapa/verde.webp', title: 'Verde por cuadro', desc: 'Medido por satélite, mes a mes.', alt: 'Capa de verde medida por satélite sobre los cuadros del campo', Icon: Sprout },
  { src: '/landing/mapa/relieve.webp', title: 'Relieve', desc: 'Dónde está el bajo y dónde se junta el agua.', alt: 'Curvas de nivel del campo, con el bajo marcado', Icon: Mountain },
  { src: '/landing/mapa/cuadro.webp', title: 'Cuadros al límite', desc: 'Qué parte de su capacidad está usando cada uno.', alt: 'Resumen de un cuadro: al 38 % de su capacidad', Icon: Gauge },
  { src: '/landing/mapa/ficha.webp', title: 'Raciones y capacidad', desc: 'Cuánto consume y cuánto aguanta, año por año.', alt: 'Ficha del cuadro con el consumo de cada año contra su capacidad', Icon: BarChart3 },
];

const MapaVistas: React.FC = () => {
  const [actual, setActual] = useState(0);

  return (
    <div className="lp-mapview">
      <div className="lp-mapview__tabs lp-rv" role="group" aria-label="Vistas del mapa">
        {VISTAS.map(({ title, desc, Icon }, i) => (
          <button
            key={title}
            type="button"
            className={i === actual ? 'on' : undefined}
            aria-pressed={i === actual}
            onClick={() => setActual(i)}
          >
            <Icon className="lp-ico" aria-hidden="true" />
            <span>
              <b>{title}</b>
              <span>{desc}</span>
            </span>
          </button>
        ))}
      </div>
      <figure className="lp-mapview__shot lp-rv lp-d1">
        <div className="lp-mapview__frame">
          {VISTAS.map((v, i) => (
            <img
              key={v.src}
              src={v.src}
              alt={i === actual ? v.alt : ''}
              aria-hidden={i !== actual}
              className={i === actual ? 'on' : undefined}
              loading="lazy"
              width={636}
              height={592}
            />
          ))}
        </div>
        <figcaption>Imágenes: Google, Copernicus Sentinel-2. Relieve: OpenTopoMap (CC-BY-SA), NASA SRTM.</figcaption>
      </figure>
    </div>
  );
};

export default MapaVistas;
